/* unplugin-vue-components disabled */import script from "./RateLevel.vue?vue&type=script&name=RateLevel&setup=true&lang=js"
export * from "./RateLevel.vue?vue&type=script&name=RateLevel&setup=true&lang=js"

import "./RateLevel.vue?vue&type=style&index=0&id=0e84b484&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e84b484"]])

export default __exports__